var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"modal",attrs:{"id":"modal-1","title":_vm.title},on:{"ok":_vm.action}},[_c('the-body')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }